import { SDK, T } from '@homeschooling/sdk'

import Persistence from './Persistence'
Persistence.setValues()

type AvailableSDKs =
  SDK.Users | SDK.Schedule | SDK.Notes | SDK.Expenses | SDK.Students

// Factory dispatcher for various SDKs (pre-initialized and ready for use)
export class SDKFactory {
  public getEnv (): T.Env {
    return Persistence.getEnv()
  }

  public getJwt (): string {
    return Persistence.getJwt()
  }

  public getUsersSDK (): SDK.Users {
    return this.init(new SDK.Users(this.fetcher)) as SDK.Users
  }

  public getScheduleSDK (): SDK.Schedule {
    return this.init(new SDK.Schedule(this.fetcher)) as SDK.Schedule
  }

  public getNotesSDK (): SDK.Notes {
    return this.init(new SDK.Notes(this.fetcher)) as SDK.Notes
  }

  public getExpensesSDK (): SDK.Expenses {
    return this.init(new SDK.Expenses(this.fetcher)) as SDK.Expenses
  }

  public getStudentSDK (): SDK.Students {
    return this.init(new SDK.Students(this.fetcher)) as SDK.Students
  }

  private fetcher = async function fetcher (uri: string, params: {}) {
    return fetch(uri, params)
  }

  private init (sdk: any): AvailableSDKs {
    return sdk
     .setJwt(this.getJwt()) // Hardcode the JWT on init
     .setEnv(this.getEnv()) as AvailableSDKs
     // .setMockMode(this.getMockMode())//.setGetJwtCb(Persistence.getJwt.bind(Persistence)) // Dynamically snag JWT on each request.
     // .setEnv(this.getEnv()) as AvailableSDKs
  }
}

// If we allow coercion, it will change string numbers to real numbers etc.
// On QA/Prod, we don't want type exceptions to throw problems here, so coercable is fine.
// For our lower environments, someday we should enforce proper typing of responses.
// TODO: When that date arrives, uncomment this line.
// const coerceData = ![undefined, 'dev', 'local'].includes(Persistence.getEnv())
//const coerceData = true

//export const getValidator = () => ValidatorFactory(coerceData)
const factory = new SDKFactory()
export default factory